import type { Product, ProductVariant } from '~/types/models/product'
import { getDefaultVariant } from './getDefaultVariant'

export function getVariantFromSku(sku: string, product: Product) {
  const variant: ProductVariant[] = product.variants.filter(product => product.sku === sku)
  return variant[0]! || getDefaultVariant(product)
}
